import { ENV } from '@/script/proj_env';

class Kodepay {
  /**
   * 初始化
   */
  init () {
    window.KODEPAY_APPLICATION_ID = ENV.currentConfig.kodepay.applicationID;
    window.KODEPAY_CLIENT_ID = ENV.currentConfig.kodepay.clientID;
    window.KODEPAY_ENV = ENV.isProd ? 'production' : 'development';
    window.kodepayCallbackBind = false;
    const s = document.createElement('script');
    s.referrerPolicy = 'no-referrer';
    s.src =
      'https://kodepay-global.zingfront.com/resource/kodepay/2.1.4/kodepay-website.js';
    s.async = true;
    document.head.appendChild(s);
  }

  /**
   * 请求支付链接
   * @param {商品id} priceId
   * @param {订单id} orderId
   * @param {重定向路径} redirectPath
   * @returns 支付链接
   */
  async request (priceId, orderId, redirectPath) {
    const redirectURL = `${window.location.protocol}//${window.location.host}${redirectPath}`;
    return new Promise((resolve) => {
      window.KodePay.open_payment_page_new(priceId, {
        origin_data: { orderId },
        redirect_url: redirectURL,
        width: 1000,
        height: 800,
      }).then((res) => {
        if (res.code === 'success') {
          console.log(res.data);
          resolve(res.data);
        } else {
          console.log(res);
          resolve('');
        }
      });
    });
  }
}
const kodepay = new Kodepay();
export default kodepay;
